import React, { useState } from "react";
import PropTypes from "prop-types";
import AuthFooterTabs from "./AuthFooterTabs";
import FooterCalculatorDialog from "./FooterCalculatorDialog";
import SupportContactDialog from "../../../components/SupportContactDialog";

export default function GuestPageFooter({ supportContext = "Guest Request" }) {
  const [openCalculator, setOpenCalculator] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);

  return (
    <>
      <AuthFooterTabs
        setOpenSupport={setOpenSupport}
        setOpenCalculator={setOpenCalculator}
      />
      <SupportContactDialog
        open={openSupport}
        onClose={() => setOpenSupport(false)}
        context={supportContext}
      />
      <FooterCalculatorDialog
        open={openCalculator}
        onClose={() => setOpenCalculator(false)}
      />
    </>
  );
}

GuestPageFooter.propTypes = {
  supportContext: PropTypes.string,
};
